import { Fragment } from 'react'
import _ from '@strings'
import classNames from 'classnames'
import is from 'is_js'
import { useSelector } from 'react-redux'
import { formatDate } from '@utils/helpers'

import Text from '@components/Ui/Text'
import Spacer from '@components/Ui/Spacer'
import Icon from '@components/Ui/Icon'
import styles from './TimeSelect.scss'

const TimeSelect = ({ selected, slots, selectTime, selectedDate }) => {
  const mode = useSelector((s) => s.data.mode)
  const isCustom = slots?.some((slot) => slot.custom)

  return (
    <div className={styles.base} id={'time-slots'}>
      <div>
        {is.empty(slots) && (
          <Text type="robo_md_bold">
            {_('datetime.no_appointment_availabile', {
              date: formatDate(Date.parse(selectedDate), 'dd.MMMM'),
            })}
          </Text>
        )}
        {is.not.empty(slots) && (
          <Fragment>
            {mode === 'live' && (
              <Text type="robo_md_bold">
                {_('datetime.appointment_availabile', {
                  date: formatDate(Date.parse(selectedDate), 'dd.MMMM'),
                })}
              </Text>
            )}
            {mode === 'restricted' && (
              <Text type="robo_md_bold">{_('datetime.select_period')}</Text>
            )}
            <Spacer vertical scale="0.5" />
            <div className={classNames(styles.slots, { [styles.custom]: isCustom })}>
              {slots.map((slot) => (
                <button
                  type="button"
                  key={slot.startTime}
                  onClick={() => selectTime(slot)}
                  data-e2e="appointments-time"
                  className={classNames(styles.slot, {
                    [styles.isActive]: selected === slot.startTime,
                  })}
                >
                  <div className={styles.icon}>
                    <Icon
                      type={selected === slot.startTime ? 'clock' : 'clock'}
                      size={selected === slot.startTime ? '24' : '24'}
                    />
                  </div>
                  {slot.custom && (
                    <Text type="robo_md" as="div" style={{ lineHeight: '1' }}>
                      {slot.startTime && slot.endTime && (
                        <Fragment>
                          {`${slot.startTime.slice(0, -3)} - ${slot.endTime.slice(0, -3)}`}
                          <br />
                        </Fragment>
                      )}
                      {slot.prefix}
                    </Text>
                  )}
                  {!slot.custom && (
                    <Text type="robo_md" as="div" style={{ lineHeight: '1' }}>
                      {slot.startTime.slice(0, -3)} {_('datetime.time')}
                    </Text>
                  )}
                </button>
              ))}
            </div>
          </Fragment>
        )}
        <Spacer vertical scale="1" />
        {mode === 'restricted' && (
          <Text type="robo_md_bold">{_('datetime.selected_restricted')}</Text>
        )}
      </div>
    </div>
  )
}

TimeSelect.defaultProps = {
  selected: null,
  slots: [],
  selectTime: () => {},
}
TimeSelect.propTypes = {}

export default TimeSelect
